{% block prems_discount_category_detail_statistics %}
    <div>
        <mt-card
            class="prems_discount_category_detail_statistics__base"
            :title="$tc('prems-discount-category.detail.card.statistics.title')"
            :large="false"
            v-if="records && !isLoading"
        >
            {% block prems_discount_category_detail_statistics_sold_products_listing %}
            <sw-container
                columns="1fr 1fr"
                gap="50px 100px"
            >
                <div class="info">
                    <div class="key">
                        {{ $tc('prems-discount-category.detail.card.statistics.field.numberOfOrders') }}
                        :
                    </div>
                    <div class="value">
                        {{ discountCategory.numberOfOrders ? discountCategory.numberOfOrders : 0 }}
                    </div>
                </div>
                <div class="info">
                    <div class="key">
                        {{ $tc('prems-discount-category.detail.card.statistics.field.margin') }}
                        :
                    </div>
                    <div class="value">
                            {{ (totalMargin).toFixed(2) }} €
                        </div>
                </div>
                <div class="info">
                    <div class="key">
                        {{ $tc('prems-discount-category.detail.card.statistics.field.numberOfDiscountedProducts') }}
                        :
                    </div>
                    <div class="value">
                            {{ records.length }}
                        </div>
                </div>
                <div class="info">
                    <div class="key">
                        {{ $tc('prems-discount-category.detail.card.statistics.field.totalAmount') }}
                        :
                    </div>
                    <div class="value">
                            {{ (totalAmount).toFixed(2) }} €
                        </div>
                </div>
            </sw-container>
            {% endblock %}
        </mt-card>
        <mt-card
            class="prems_discount_category_detail_statistics__table"
            :title="$tc('prems-discount-category.detail.card.statistics.listingTitle')"
            :large="false"
        >
            {% block prems_discount_category_detail_statistics_sold_products_listing %}
            <sw-empty-state
                v-if="(!records || !records.length) && !isLoading"
                :title="$tc('prems-discount-category.detail.card.statistics.field.emptyOrdersDescription')"
                :subline="''"
                :absolute="false"
            >
                <template #icon>
                    <img
                        :src="assetFilter('/administration/static/img/empty-states/products-empty-state.svg')"
                        alt
                    />
                </template>
            </sw-empty-state>
            <sw-entity-listing
                v-else
                :columns="statisticsColumns"
                :repository="statisticsRepository"
                :items="records"
                :allow-column-edit="false"
                :allow-delete="false"
                :show-settings="false"
                :show-selection="false"
                :showActions="false"
                :full-page="false"
                :is-loading="isLoading"
                style="border-radius: 0 0 8px 8px;"
            >
                {% block prems_discount_category_detail_statistics_column_name %}
                <template #column-name="{ item }">
                    {{ item.product.name ? item.product.name : item.product.translated.name }}
                </template>
                {% endblock %}
                    {% block prems_discount_category_detail_statistics_column_product_number %}
                <template #column-productNumber="{ item }">
                    {{ item.product.productNumber }}
                </template>
                {% endblock %}
                    {% block prems_discount_category_detail_statistics_column_sales %}
                <template #column-sales="{ item }">
                            {{ item.sales }}
                        </template>
                {% endblock %}
                    {% block prems_discount_category_detail_statistics_column_margin %}
                <template #column-margin="{ item }">
                    {{ (item.turnover.totalPrice - item.turnover.netPrice).toFixed(2) }}
                    €
                </template>
                {% endblock %}
                    {% block prems_discount_category_detail_statistics_column_turnover %}
                <template #column-turnover="{ item }">
                    {{ (item.turnover.totalPrice).toFixed(2) }}
                    €
                </template>
                {% endblock %}
            </sw-entity-listing>
            {% endblock %}
        </mt-card>
    </div>
{% endblock %}